module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAAAXNSR0IArs4c6QAAAQJJREFUKFOVkb1KxUAQhc9ZgiRGH8IqEiSQ3XewtFHUysaLjbfzQS7aKAqidl4r3yO5S5oUdr6BlQQJO7KSSPAn6LQz55s5Z5jn+aFS6kxE7klOy7J8xT/KGLMM4FxEtgFM6bVZlm0EQTAn2bZtu1NV1dNfmMaYdQAPAOic27XW1h9AX2markRRdAFgS0Qmi8ViPgbN83yf5JUHDp19AnuxMWYC4FRErpumOanr+m0ITtN0KQzDGYCDDnQ77H8D+qbWOiPpL3xxzu1Za5+7aNa6aKLe4lcXPwL9UJIkq3EcX5Lc9NeIiCJ5IyKPY8/7Fdhv1lofkZyJiFNKHRdFcTeW7TtbDGT+Iz0dqwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiala.png
// module id = X4LS
// module chunks = 26